export default "__VITE_ASSET__DQUCZFSN__"